function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('./../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];
var YoutubeInitStream = require('./lib/yt-client-init-stream');
var YoutubeClient = /*#__PURE__*/function (_ModTemplate) {
  function YoutubeClient(app) {
    var _this;
    _classCallCheck(this, YoutubeClient);
    _this = _callSuper(this, YoutubeClient, [app]);
    _this.app = app;
    _this.slug = 'youtube-client';
    _this.name = 'youtube-client';
    _this.description = 'UI for connecting to youtube stream';
    _this.categories = 'Utilities Communications';
    _this["class"] = 'utility';
    _this.status = 'beta';
    _this.publickey = '';
    _this.styles = ['/youtube-client/style.css', '/saito/saito.css'];
    _this.stream_key = '';
    _this.stream_type = 'main';
    _this.stream_url = {
      main: 'rtmp://a.rtmp.youtube.com/live2',
      backup: 'rtmp://b.rtmp.youtube.com/live2?backup=1'
    };
    _this.stream_status = false;
    _this.ws = null;
    _this.mediaRecorder = null;
    _this.icon_id = '';
    _this.combined_stream = null;
    _this.app.connection.on('saito-yt-start-stream', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var obj,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            obj = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _this.stream_key = obj.stream_key;
            //this.stream_type = obj.stream_type;
            document.addEventListener('visibilitychange', _this.visibilityChange.bind(_this));
            _context.n = 1;
            return _this.startStream();
          case 1:
            _this.startStreamStatus();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _this.app.connection.on('saito-yt-stop-stream', function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.stream_status == true) {
        _this.stopStreamStatus();
      }
    });
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(YoutubeClient, _ModTemplate);
  return _createClass(YoutubeClient, [{
    key: "initialize",
    value: function initialize(app) {
      _superPropGet(YoutubeClient, "initialize", this, 3)([app]);
      if (this.browser_active) {
        this.styles = ['/youtube-client/style.css', '/saito/saito.css'];
      }
      if (this.app.BROWSER == 0) {}
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      var this_self = this;
      if (type === 'dream-controls') {
        var x = [];
        x.push({
          text: "Youtube Stream",
          icon: 'fa-brands fa-youtube',
          callback: function callback(app, id, combined_stream) {
            this_self.icon_id = "dream_controls_menu_item_".concat(id);
            this_self.combined_stream = combined_stream;
            console.log('combined_stream ///', combined_stream);
            if (this_self.stream_status == false) {
              var init = new YoutubeInitStream(this_self.app, this_self.mod);
              init.render();
            } else {
              this_self.stopStreamStatus();
            }
          } // callback
        }); // x

        return x;
      } // type = dream-controls
    } // respondTo
  }, {
    key: "startStream",
    value: function () {
      var _startStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var this_self, mediaStream, ws_url;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this_self = this;
              _context2.n = 1;
              return this.getStreamData();
            case 1:
              mediaStream = _context2.v;
              console.log('mediaStream:', mediaStream);
              if (mediaStream == false) {
                siteMessage('Error while fetching mediaStream', 2000);
              }
              ws_url = window.location.protocol.replace('http', 'ws') + '//' +
              // http: -> ws:, https: -> wss:
              window.location.hostname + this.getPort() + '/encoder?url=' + encodeURIComponent("".concat(this.stream_url[this.stream_type], "/").concat(this_self.stream_key));
              console.log('url:', ws_url);
              this_self.ws = new WebSocket(ws_url, 'echo-protocol');
              this_self.ws.addEventListener('open', function (e) {
                console.log('WebSocket Open', e);
                this_self.mediaRecorder = new MediaRecorder(mediaStream, {
                  mimeType: this_self.getMIME(),
                  videoBitsPerSecond: 1.5 * 1024 * 1024
                });
                this_self.mediaRecorder.addEventListener('dataavailable', function (e) {
                  //console.log('dataavailable',e.data);
                  this_self.ws.send(e.data);
                });
                this_self.mediaRecorder.addEventListener('stop', function (e) {
                  this_self.ws.close(1000);
                });
                this_self.mediaRecorder.start(1000); // Start recording, and dump data every second
              });
              this_self.ws.addEventListener('close', function (e) {
                console.log('WebSocket Close', e);
                this_self.mediaRecorder.stop(1000);
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function startStream() {
        return _startStream.apply(this, arguments);
      }
      return startStream;
    }()
  }, {
    key: "startStreamStatus",
    value: function startStreamStatus() {
      if (document.getElementById(this.icon_id)) {
        document.getElementById(this.icon_id).classList.add('yt-active');
      }
      siteMessage('Youtube live stream started', 2000);
      this.stream_status = true;
    }
  }, {
    key: "stopStreamStatus",
    value: function stopStreamStatus() {
      if (document.getElementById(this.icon_id)) {
        document.getElementById(this.icon_id).classList.remove('yt-active');
      }
      this.stream_status = false;
      siteMessage('Youtube live stream stopped', 2000);
      this.mediaRecorder.stop(1000);
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var this_mod;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.browser_active) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this_mod = this;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "getStreamData",
    value: function () {
      var _getStreamData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var mods, i, limbo, options;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              mods = this.app.modules.mods;
              i = 0;
            case 1:
              if (!(i < mods.length)) {
                _context4.n = 5;
                break;
              }
              if (!(typeof mods[i].slug != 'undefined')) {
                _context4.n = 4;
                break;
              }
              if (!(mods[i].slug == 'swarmcast')) {
                _context4.n = 4;
                break;
              }
              limbo = mods[i];
              console.log('limbo mod: ', limbo);
              if (!(limbo.combinedStream == null)) {
                _context4.n = 3;
                break;
              }
              options = {
                identifier: 'Swarmcast',
                description: limbo.description
              };
              console.log('options:', options);
              _context4.n = 2;
              return limbo.getStream(options);
            case 2:
              console.log('limbo mod after: ', limbo);
            case 3:
              return _context4.a(2, limbo.combinedStream);
            case 4:
              i++;
              _context4.n = 1;
              break;
            case 5:
              return _context4.a(2, false);
          }
        }, _callee4, this);
      }));
      function getStreamData() {
        return _getStreamData.apply(this, arguments);
      }
      return getStreamData;
    }()
  }, {
    key: "getPort",
    value: function getPort() {
      // 44344 - test, prod
      // 3000 - local dev
      var port = '';
      var protocol = this.app.browser.protocol;
      console.log('protocol:', protocol);
      if (protocol == 'http:') {
        port = ":".concat(this.app.browser.port);
      }
      console.log('port:', port);
      return port;
    }
  }, {
    key: "getMIME",
    value: function getMIME() {
      var mime = 'video/webm;codecs=h264';
      var isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
      if (isFirefox) {
        var supported = this.getAllSupportedMimeTypes();
        console.log('supported mimes: ', supported);
        for (var i = 0; i < supported.length; i++) {
          if (supported[i] == 'video/webm;codecs="vp8.0, opus"') {
            mime = supported[i];
            break;
          }
        }
      }
      console.log('mime:', mime);
      return mime;
    }
  }, {
    key: "getAllSupportedMimeTypes",
    value: function getAllSupportedMimeTypes() {
      for (var _len = arguments.length, mediaTypes = new Array(_len), _key = 0; _key < _len; _key++) {
        mediaTypes[_key] = arguments[_key];
      }
      if (!mediaTypes.length) mediaTypes.push('video', 'audio');
      var CONTAINERS = ['webm', 'ogg', 'mp3', 'mp4', 'x-matroska', '3gpp', '3gpp2', '3gp2', 'quicktime', 'mpeg', 'aac', 'flac', 'x-flac', 'wave', 'wav', 'x-wav', 'x-pn-wav', 'not-supported'];
      var CODECS = ['vp9', 'vp9.0', 'vp8', 'vp8.0', 'avc1', 'av1', 'h265', 'h.265', 'h264', 'h.264', 'opus', 'vorbis', 'pcm', 'aac', 'mpeg', 'mp4a', 'rtx', 'red', 'ulpfec', 'g722', 'pcmu', 'pcma', 'cn', 'telephone-event', 'not-supported'];
      return [].concat(_toConsumableArray(new Set(CONTAINERS.flatMap(function (ext) {
        return mediaTypes.flatMap(function (mediaType) {
          return ["".concat(mediaType, "/").concat(ext)];
        });
      }))), _toConsumableArray(new Set(CONTAINERS.flatMap(function (ext) {
        return CODECS.flatMap(function (codec) {
          return mediaTypes.flatMap(function (mediaType) {
            return [
            // NOTE: 'codecs:' will always be true (false positive)
            "".concat(mediaType, "/").concat(ext, ";codecs=").concat(codec)];
          });
        });
      }))), _toConsumableArray(new Set(CONTAINERS.flatMap(function (ext) {
        return CODECS.flatMap(function (codec1) {
          return CODECS.flatMap(function (codec2) {
            return mediaTypes.flatMap(function (mediaType) {
              return ["".concat(mediaType, "/").concat(ext, ";codecs=\"").concat(codec1, ", ").concat(codec2, "\"")];
            });
          });
        });
      })))).filter(function (variation) {
        return MediaRecorder.isTypeSupported(variation);
      });
    }
  }, {
    key: "visibilityChange",
    value: function visibilityChange() {
      salert('You navigated away from this tab. To ensure the best streaming experience, please keep this tab in focus');
    }
  }]);
}(ModTemplate);
module.exports = YoutubeClient;